/**
 * @documental
 * @export Regular
 * @type
 * typographyComponent
 * @use
 * The `Regular` component should be used to specify a region of text as normal.
 * @element
 * span
 * @className
 * regular
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import styles from "./styles.module.scss";

/**
 * The Regular component properties.
 */

export interface RegularProps extends BaseProps {}

/**
 * Specifies that text content should be displayed as regular text. Can be overridden
 * through the use of the [Bold](../Bold/README.md) and [Semibold](../Semibold/README.md)
 * components.
 */
export const Regular: FC<PropsWithChildren<RegularProps>> = (props) => {
  const { children } = props;
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Regular, "regular"] });

  return <span {...baseHtmlProps}>{children}</span>;
};
